import { render, staticRenderFns } from "./GridItem.vue?vue&type=template&id=946973ea&scoped=true"
import script from "./GridItem.vue?vue&type=script&lang=ts"
export * from "./GridItem.vue?vue&type=script&lang=ts"
import style0 from "./GridItem.vue?vue&type=style&index=0&id=946973ea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946973ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('946973ea')) {
      api.createRecord('946973ea', component.options)
    } else {
      api.reload('946973ea', component.options)
    }
    module.hot.accept("./GridItem.vue?vue&type=template&id=946973ea&scoped=true", function () {
      api.rerender('946973ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/GridItem.vue"
export default component.exports